var _defs, _rect, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgNewZealand = function SvgNewZealand(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: 600,
    width: 1200,
    ref: ref
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Canton"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 L 600,0 L 600,300 L 0,300 z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Diagonals"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 L 300,150 L 0,150 z M 300,0 L 600,0 L 300,150 z M 300,150 L 600,150 L 600,300 z M 300,150 L 300,300 L 0,300 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Pentagram"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arm",
    transform: "translate(0,-0.324925)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 L 0,0.5 L 1,0 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 L 0,-0.5 L 1,0 z",
    transform: "rotate(-36,1,0)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Arm",
    transform: "scale(-1,1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Arm",
    transform: "rotate(72,0,0)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Arm",
    transform: "rotate(-72,0,0)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Arm",
    transform: "rotate(-72,0,0) scale(-1,1)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#00247d",
    x: 0,
    y: 0,
    width: 1200,
    height: 600
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flag_of_the_United_Kingdom"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Saint_Andrews_Cross",
    stroke: "#ffffff",
    d: "M 0,0 L 600,300 M 0,300 L 600,0",
    strokeWidth: 60,
    clipPath: "url(#Canton)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Saint_Patricks_Cross",
    stroke: "#cc142b",
    d: "M 0,0 L 600,300 M 0,300 L 600,0",
    strokeWidth: 40,
    clipPath: "url(#Diagonals)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Saint_Georges_Cross"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff",
    d: "M 300,0 L 300,300 M 0,150 L 600,150",
    strokeWidth: 100,
    clipPath: "url(#Canton)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#cc142b",
    d: "M 300,0 L 300,300 M 0,150 L 600,150",
    strokeWidth: 60,
    clipPath: "url(#Canton)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Southern_Cross"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gamma_Crucis"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Pentagram",
    fill: "#ffffff",
    transform: "translate(900,120) scale(45.4)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Pentagram",
    fill: "#cc142b",
    transform: "translate(900,120) scale(30)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(82,900,240)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Delta_Crucis"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Pentagram",
    fill: "#ffffff",
    transform: "translate(900,120) rotate(-82) scale(40.4)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Pentagram",
    fill: "#cc142b",
    transform: "translate(900,120) rotate(-82) scale(25)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Beta_Crucis"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Pentagram",
    fill: "#ffffff",
    transform: "translate(900,380) rotate(-82) scale(45.4)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Pentagram",
    fill: "#cc142b",
    transform: "translate(900,380) rotate(-82) scale(30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Alpha_Crucis"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Pentagram",
    fill: "#ffffff",
    transform: "translate(900,480) scale(50.4)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Pentagram",
    fill: "#cc142b",
    transform: "translate(900,480) scale(35)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNewZealand);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,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";